var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { first } from 'lodash';
import { classNames } from '@shapeable/utils';
import { ContentNode } from './content-node';
import { ImageEntity } from './image-entity';
import { useColorInfo } from '../hooks/use-color-info';
import { ContentEntityRichTitle } from './content-entity-rich-title';
var cls = classNames('slice-blurb-video');
export var SliceBlurbImageDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: inherit;\n    font-size: 1em;\n    font-weight: 300;\n  "], ["\n    color: inherit;\n    font-size: 1em;\n    font-weight: 300;\n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "]))),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "]))),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 66.66667%;\n  "], ["\n    width: 66.66667%;\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    color: inherit;\n    font-family: ", ";\n    font-weight: 500;\n    font-size: ", "em;\n    line-height: 1.35em;\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n    margin-top: 0;\n    ", "\n  "], ["\n    color: inherit;\n    font-family: ", ";\n    font-weight: 500;\n    font-size: ", "em;\n    line-height: 1.35em;\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n    margin-top: 0;\n    ", "\n  "])), theme.FONT('heading'), 38 / 18, theme.UNIT(8), theme.UNIT(8), function (_a) {
    var _color = _a._color;
    return _color && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.H_DOT_BG_END(_color, 2, 6));
  }),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme.UNIT(8))
});
var ContentStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-size: 1em;\n    width: 100%;\n    color: inherit;\n    box-sizing: border-box;\n    padding-bottom: ", ";\n  "], ["\n    font-size: 1em;\n    width: 100%;\n    color: inherit;\n    box-sizing: border-box;\n    padding-bottom: ", ";\n  "])), theme.UNIT(4)),
  tablet: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme.UNIT(8))
});
var ImageStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    flex-shrink: 0;\n    width: 100%;\n\n    img {\n      object-fit: contain !important;\n    }\n    \n  "], ["\n    flex-shrink: 0;\n    width: 100%;\n\n    img {\n      object-fit: contain !important;\n    }\n    \n  "]))),
  tablet: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    width: 33.3333%;\n  "], ["\n    width: 33.3333%;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div.attrs(cls.attr('layout'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: styled(ContentEntityRichTitle)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Content: styled(ContentNode)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Image: styled(ImageEntity)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
export var SliceBlurbImage = function (props) {
  var className = props.className,
    entity = props.entity;
  var image = first(entity.images);
  var title = entity.title,
    titleRich = entity.titleRich,
    content = entity.content;
  var color = useColorInfo().color;
  var hasTitle = (titleRich === null || titleRich === void 0 ? void 0 : titleRich.text) || title;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Layout, null, React.createElement(My.Body, null, hasTitle && React.createElement(My.Title, {
    _color: 'strong',
    entity: entity
  }), React.createElement(My.Content, {
    entity: content
  })), image && React.createElement(My.Image, {
    aspectRatio: {
      base: 16 / 9
    },
    entity: image
  })));
};
SliceBlurbImage.defaultProps = SliceBlurbImageDefaultProps;
SliceBlurbImage.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;